module.exports = "/_next/static/images/google-play-576227b48f1da37429691b4716ddb114.png.webp";